// extracted by mini-css-extract-plugin
module.exports = {"task-load":"styles_task-load__2EGZB","task-urgent":"styles_task-urgent___NOES"};